import AreaService from "src/services/AreaService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {};
export const params = {
	name: "",
};

const module = {
	state: {},
	mutations: {},
	getters: {},
	actions: {},
	types: types
};
export default ModuleCreator({ name: "area", plural: "areas" }, AreaService, module, types, params);
